export enum ThemedImageName {
  Refuse = 'refuse',
  Save = 'save',
  Send = 'send',
  Error = 'error',
  Puzzle = 'puzzle',
  Sign = 'sign',
  Delete = 'delete',
  Check = 'check',
}
